<template>
  <v-modal
    v-if="true"
    @hide-modal="$emit('hide-modal')"
  >
    <template v-slot:title>
      <h3>
        {{ $t('phrase.change_email') }}
      </h3>
      <p class="text-muted">
        {{ $t('sentence.change_email_explanation') }}
        <span class="text-danger">{{ $t('sentence.change_email_dont_logout') }}</span>
      </p>
    </template>
    <template v-slot:body>
      <form
        method="post"
        @submit.prevent="submit"
      >
        <div class="mb-3">
          <v-text-input
            id="change-email-email"
            label="phrase.new_email"
            v-model="data.email"
            :errors="errors.email"
            type="email"
          />
        </div>
        <div class="mb-3">
          <v-check-box
            id="change-email-news-letter"
            label="sentence.notify_me_short"
            help-text="sentence.notify_me"
            v-model="data.news_letter"
            :errors="errors.news_letter"
          />
        </div>

        <v-form-errors
          :errors="errors.non_field_errors"
        />

        <div class="d-flex justify-content-end">
          <v-button
            id="change-email-submit"
            text="word.save"
            type="submit"
            :loader="loader"
          />
        </div>
      </form>
    </template>
  </v-modal>
</template>

<script>
import Button from '@/common/components/Button.vue';
import FormErrors from '@/common/components/FormErrors.vue';
import Modal from '@/common/components/Modal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import CheckBox from '@/common/components/inputs/CheckBox.vue';
import { GenericFormMixin } from '@/common/utils/mixins';

export default {
  name: 'ChangeEmailModal',
  mixins: [
    GenericFormMixin,
  ],
  components: {
    'v-button': Button,
    'v-form-errors': FormErrors,
    'v-check-box': CheckBox,
    'v-modal': Modal,
    'v-text-input': TextInput,
  },
  data() {
    return {
      apiPath: 'email-change-requests/',
      apiMethod: 'post',
      data: {
        email: '',
        news_letter: false,
      },
    };
  },
  methods: {
    postProcess() {
      this.$router.push({
        name: 'success',
        query: { msg: 'sentence.change_email_request_success' },
      });
    },
  },
};
</script>
